import { render, staticRenderFns } from "./I18nExampleView.vue?vue&type=template&id=649ebe2c"
import script from "./I18nExampleView.ts?vue&type=script&lang=ts&external"
export * from "./I18nExampleView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports